import styles from "./bussiness.module.css";
import { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { connection } from "utils/apiConnection.ts";
import { AiFillLeftCircle } from "react-icons/ai";
import { AiOutlinePlus } from "react-icons/ai";
import Modal from "./modal/Modal";
import DeleteBussiness from "./modal/DeleteBussiness";
import ManagementCommission from "./modal/ManagementCommission.jsx";
import BoxCustomer from "./BoxCustomer";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
import Filter from "./modal/Filter";
import _ from "lodash";
import AddCampain from "./modal/AddCampain";
import ReactPaginate from "react-paginate";
import Loader from "utils/Loader";
import StopBussiness from "./modal/StopBussiness";

const Bussiness = ({ marketer }) => {
  const [selectedItem, setSelectedItem] = useState(1);
  const [customers, setCustomers] = useState([]);
  const [links, setLinks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = 12;
  const pageVisited = pageNumber * usersPerPage;
  const [updater, setUpdater] = useState(false);
  const [allProductTags, setAllProductTags] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allLeader, setAllLeader] = useState([]);
  const [editModalData, setEditModalData] = useState([]);
  const [otherInfo, setOtherInfo] = useState({
    suppliers__id: 0,
    bank_info: "",
    title: "",
    token: "",
    main_admin_uid: "",
    user_mobile: "",
    fullname: "",
    cover_file_id: [],
    path: [],
    logo_file_id: [],
    main_cat: "",
    line_ids: [],
    description: "",
    // endTime: "",
    // startTime: "",
    start_hour: "",
    start_min: "",
    finish_hour: "",
    finish_min: "",
    site: "",
    instagram: "",
    tell1: "",
    tell2: "",
    email: "",
    mobile: "",
    address: "",
    min_order_amount: ""
  });
  useEffect(() => {
    setIsLoading(true);
    let mk;
    if (marketer == true) {
      mk = { mine: true };
    } else {
      mk = { isSuperAdmin: true };
    }
    console.log("marketer : ,", marketer);
    async function loadPage() {
      // let result = await connection("superadminapi/getsuppliers", {
      //   mine: true,
      // });
      let result = await connection("superadminapi/getsuppliers", mk);
      setCustomers(_.orderBy(result.data, ["info.mtm"], ["desc"]));

      // let x = [];
      // for (let index = 0; index < result.data.length; index++) {
      //   let newObject = {};
      //   newObject = result.data[index].info;
      //   x.push(newObject);
      // }
      // let links = [];
      // for (let index = 0; index < result.data.length; index++) {
      //   let newObject = {};
      //   newObject = result.data[index].lines_link;
      //   links.push(newObject);
      // }
      // let xy = x;
      // setLinks(links);

      // setCustomers(xy);
      setIsLoading(false);
    }
    loadPage();
  }, [updater]);
  const pageCountt = Math.ceil(customers.length / usersPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  useEffect(() => {
    async function loadPage() {
      let result = await connection("superadminapi/get_add_suppliers_data", {});
      let allUsers = [];
      for (let index = 0; index < result.user_for_admin.length; index++) {
        let newObject = {};
        newObject.value = result.user_for_admin[index].id;
        newObject.label = result.user_for_admin[index].fullname;
        allUsers.push(newObject);
      }
      setAllUsers(allUsers);
    }
    loadPage();
  }, []);
  useEffect(() => {
    async function loadPage() {
      let result = await connection("superadminapi/get_add_suppliers_data", {});

      let all = [];
      for (let index = 0; index < result.lines.length; index++) {
        let newObject = {};
        newObject.value = result.lines[index].id;
        newObject.label = result.lines[index].title;
        newObject.main_cat = result.lines[index].main_cat;
        newObject.parent_line_id = result.lines[index].parent_line_id;
        all.push(newObject);
      }
      setAllProductTags(all);
    }
    loadPage();
  }, []);

  useEffect(() => {
    async function loadPage() {
      let data = await connection(
        "superadminapi/get_add_edit_product_data",
        {}
      );
      let allLeader = [];
      for (let index = 0; index < data.cats.length; index++) {
        let newObject = {};
        newObject = data.cats[index];

        allLeader.push(newObject);
      }
      setAllLeader(allLeader);
    }
    loadPage();
  }, []);
  // let chars = _.orderBy(customers, ["mtm"], ["desc"]);

  const [filterInputs, setFilterInputs] = useState({
    title: "",
    complate_order_count_from: "",
    complate_order_count_to: "",
    active_order_count_from: "",
    active_order_count_to: "",
    canceled_order_count_from: "",
    canceled_order_count_to: "",
    total_saled_amount_from: "",
    total_saled_amount_to: "",
    muid: ""
  });

  async function search() {
    setIsLoading(true);
    let myFormData = new FormData();
    if (filterInputs.title !== "") {
      myFormData.append("keyword", filterInputs.title);
    }
    if (filterInputs.complate_order_count_from !== "") {
      myFormData.append(
        "complate_order_count_from",
        filterInputs.complate_order_count_from
      );
    }
    if (filterInputs.complate_order_count_to !== "") {
      myFormData.append(
        "complate_order_count_to",
        filterInputs.complate_order_count_to
      );
    }
    if (filterInputs.active_order_count_from !== "") {
      myFormData.append(
        "active_order_count_from",
        filterInputs.active_order_count_from
      );
    }
    if (filterInputs.active_order_count_to !== "") {
      myFormData.append(
        "active_order_count_to",
        filterInputs.active_order_count_to
      );
    }
    if (filterInputs.canceled_order_count_from !== "") {
      myFormData.append(
        "canceled_order_count_from",
        filterInputs.canceled_order_count_from
      );
    }
    if (filterInputs.canceled_order_count_to !== "") {
      myFormData.append(
        "canceled_order_count_to",
        filterInputs.canceled_order_count_to
      );
    }
    if (filterInputs.total_saled_amount_from !== "") {
      myFormData.append(
        "total_saled_amount_from",
        filterInputs.total_saled_amount_from
      );
    }
    if (filterInputs.total_saled_amount_to !== "") {
      myFormData.append(
        "total_saled_amount_to",
        filterInputs.total_saled_amount_to
      );
    }
    if (filterInputs.muid !== "") {
      myFormData.append("muid", filterInputs.muid.value);
    }

    axios
      .post("http://old-sabadib.tatdemo.ir/superadminapi/getsuppliers", myFormData)
      .then(res => {
        // console.log("res.data", res.data.size);
        res.data.size == 0 ? setCustomers(0) : setCustomers(res.data.data);
        // setCustomers(res.data.data.map((v) => v.info));
        setIsLoading(false);
      });
  }

  async function resetFilters() {
    setIsLoading(true);
    setFilterInputs({
      title: "",
      complate_order_count_from: "",
      complate_order_count_to: 0,
      active_order_count_from: "",
      active_order_count_to: "",
      canceled_order_count_from: "",
      canceled_order_count_to: "",
      total_saled_amount_from: "",
      total_saled_amount_to: "",
      muid: ""
    });
    setUpdater(!updater);
    setIsLoading(false);
  }

  const deleteHandler = id => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `main_status,-1`);
    myFormData.append("conditions", `id/=/${id}`);
    axios
      .post(`http://old-sabadib.tatdemo.ir/api/Update_suppliers`, myFormData)
      .then(res => {
        if (res.data.status == 1) {
          toast.success("  کسب و کار با موفقیت حذف شد");
          setUpdater(!updater);
          setIsLoading(false);
        } else {
          toast.error("  خطا در حذف کردن کسب و کار!");
          setIsLoading(false);
        }
      });
  };
  const stopHandler = id => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `main_status,-2`);
    myFormData.append("conditions", `id/=/${id}`);
    axios
      .post(`http://old-sabadib.tatdemo.ir/api/Update_suppliers`, myFormData)
      .then(res => {
        if (res.data.status == 1) {
          toast.success("  کسب و کار با موفقیت متوقف شد");
          setUpdater(!updater);
          setIsLoading(false);
        } else {
          toast.error("  خطا در متوقف کردن کسب و کار!");
          setIsLoading(false);
        }
      });
  };
  const activeHandler = id => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `main_status,0`);
    myFormData.append("conditions", `id/=/${id}`);
    axios
      .post(`http://old-sabadib.tatdemo.ir/api/Update_suppliers`, myFormData)
      .then(res => {
        if (res.data.status == 1) {
          toast.success("  کسب و کار با موفقیت فعال شد");
          setUpdater(!updater);
          setIsLoading(false);
        } else {
          toast.error("  خطا در فعال کردن کسب و کار!");
          setIsLoading(false);
        }
      });
  };

  return (
    <div className="container w-100">
      {/* <div className="d-flex border w-100">
        <div className=" border-end" style={{ width: "20%" }}>
          <h5>لاینها</h5>
          <div>
            آرایشی بهداشتی , آجیل و خشکبار , پسته , بادام زمینی , بادام درختی ,
            بادام هندی , تخمه کدو , تخمه ژاپنی , تخمه آفتابگردان , فندق , گردو ,
            انجیر خشک و توت , میوه , میوه روز , میوه خاص , کنسرو و غذای اماده ,
            خورشت , سوپ , فست فودهای آماده , پروتئینی آماده
          </div>
        </div>
        <div className={``} style={{ width: "80%" }}>
          <div className="d-flex border-bottom ">
            <div className="border-end" style={{ width: "70%" }}>
              <h5 className="border-bottom">عنوان</h5>
              <div>عنوان فروشگاه</div>
            </div>
            <div className="border-end" style={{ width: "30%" }}>
              <h5 className="border-bottom">لوگو</h5>
              <div>لوگو فروشگاه</div>
            </div>
          </div>
          <div className="d-flex border-bottom">
            <div className="border-end" style={{ width: "25%" }}>
              <h5 className="border-bottom">امار1</h5>
              <div>7777</div>
            </div>
            <div className="border-end" style={{ width: "25%" }}>
              <h5 className="border-bottom">امار2</h5>
              <div>9999</div>
            </div>
            <div className="border-end" style={{ width: "25%" }}>
              <h5 className="border-bottom">امار 3</h5>
              <div>555</div>
            </div>
            <div className="border-end" style={{ width: "25%" }}>
              <h5 className="border-bottom">امار4</h5>
              <div>9999</div>
            </div>
          </div>
          <div className="d-flex border-bottom">
            <div className="border-end" style={{ width: "70%" }}>
              <h5 className="border-bottom">توضیحات</h5>
              <div>
                تتتتتتتتتتتتتتتتتتتتتتت تتتتتتتتتتتتتتتتتتتتتتتتتت تمدئ{" "}
              </div>
            </div>
            <div className="border-end" style={{ width: "30%" }}>
              <h5 className="border-bottom">عملیات</h5>
              <div> 8 8 8 8 8 88</div>
            </div>
          </div>
        </div>
      </div> */}
      {isLoading && <Loader></Loader>}
      {customers.length > 0 ? (
        customers
          .slice(pageVisited, pageVisited + usersPerPage)
          .map((item, index) => {
            return (
              <div>
                <BoxCustomer
                  item={item.info}
                  allProductTags={allProductTags}
                  setAllProductTags={setAllProductTags}
                  allLeader={allLeader}
                  setAllLeader={setAllLeader}
                  key={item.id}
                  allUsers={allUsers}
                  links={item.lines_link}
                  setLinks={setLinks}
                  setAllUsers={setAllUsers}
                  // chars={chars}
                  customers={customers[index]}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  setCustomers={setCustomers}
                  index={index}
                  otherInfo={otherInfo}
                  setOtherInfo={setOtherInfo}
                  deleteHandler={() => deleteHandler(item.id)}
                  stopHandler={() => stopHandler(item.suppliers__id)}
                  setEditModalData={setEditModalData}
                  editModalData={editModalData}
                  activeHandler={activeHandler}
                />
              </div>
            );
          })
      ) : (
        <p>کسب و کار وجود ندارد</p>
      )}

      <div className=" d-flex justify-content-center">
        <ReactPaginate
          // breakLabel={<a href="">...</a>}
          previousLabel={"قبلی"}
          nextLabel={"بعدی"}
          pageRangeDisplayed={2}
          marginPagesDisplayed={0}
          pageCount={pageCountt}
          onPageChange={changePage}
          containerClassName={"paginationBttn"}
          activeClassName={"paginationActive"}
          disabledClassName={"paginationDisabled"}
          nextLinkClassName={"nextBttn"}
          previousLinkClassName={"previousBttn"}
        />
      </div>

      <Filter
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        search={search}
        resetFilters={resetFilters}
      />
      <AddCampain
        setUpdater={setUpdater}
        updater={updater}
        setIsLoading={setIsLoading}
      />
      <Modal
        setIsLoading={setIsLoading}
        editModalData={editModalData}
        index={selectedItem}
        setUpdater={setUpdater}
        updater={updater}
        customers={customers}
        EditUser={setCustomers}
        otherInfo={otherInfo}
        setOtherInfo={setOtherInfo}
        allProductTags={allProductTags}
        allUsers={allUsers}
        allLeader={allLeader}
        setAllLeader={setAllLeader}
        setAllUsers={setAllUsers}
        setAllProductTags={setAllProductTags}
      />
      {/* <!--Modal Trash--> */}
      <DeleteBussiness
        index={selectedItem}
        customers={customers}
        deleteHandler={deleteHandler}
      />
      <StopBussiness
        index={selectedItem}
        customers={customers}
        stopHandler={stopHandler}
      />
      {/* <ManagementCommission
        index={selectedItem}
        otherInfo={otherInfo}
      
      /> */}
      {/* <!--Modal Edit--> */}
    </div>
  );
};

export default Bussiness;
